module.exports = __webpack_public_path__ + "static/media/step-one.de9b4667.svg";